import { foodImage, logo } from "@/assets";

const Template3 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const logoImage = template?.logo_url || logo;
  const title = previewData?.title || (isStrictPreview ? "No provide" : "GIFT VOUCHER");
  const customerName =
    previewData?.customerName || (isStrictPreview ? "No provide" : "Md Rasel Mahmud");
  const code = previewData?.code || (isStrictPreview ? "No provide" : "32154232");
  const message = previewData?.message || (isStrictPreview ? "No provide" : "Happy Birthday");
  const templateNote = previewData?.template_note;

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="c2c-template"
        className="relative w-full max-w-2xl h-[300px] items-end shadow-2xl overflow-hidden rounded-sm flex"
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>

        <div className="relative z-10 w-[58%] h-[95%] bg-white rounded-tr-[40px] flex flex-col justify-between p-5 py-4 shadow-xl">
          <div>
            <h1 className="text-xl font-bold text-[#7A4108] uppercase tracking-tighter leading-none mb-1">
              {title}
            </h1>

            <div className="space-y-0.5 mb-1.5">
              <p className="text-sm font-bold text-gray-900 tracking-tight">
                {customerName}
              </p>
              <p className="text-[10px] font-medium text-gray-500">
                Code: {code}
              </p>
            </div>

            {previewData?.items && previewData.items.length > 0 ? (
              <div className="mb-1.5 w-full text-left">
                <p className="text-[9px] uppercase tracking-widest text-[#7A4108] font-bold mb-0.5">GIFT ITEMS</p>
                <p className="text-[11px] text-gray-800 font-mono leading-tight">
                  {previewData.items.map((item) => {
                    const name = item?.menu_item?.name || item?.name || "";
                    const variant = item?.variant?.name ? ` (${item.variant.name})` : item?.variant_name ? ` (${item.variant_name})` : "";
                    return `${name}${variant}`;
                  }).join(", ")}
                </p>
              </div>
            ) : previewData?.reward ? (
              <div className="mb-1.5 px-2 py-0.5 bg-amber-100 border border-amber-300 rounded text-amber-800 font-bold text-xs inline-block w-fit">
                Value: £{previewData.reward}
              </div>
            ) : null}

            {templateNote ? (
              <p className="text-[11px] text-gray-600 font-sans leading-tight mt-1">
                {templateNote}
              </p>
            ) : null}
          </div>

          <div className="flex flex-col gap-1.5 border-t border-gray-100 pt-2 mt-auto">
            <p className="text-sm font-serif italic text-[#164E63] tracking-tight leading-none">
              {message}
            </p>
            <div className="flex justify-between items-center">
              <img
                src={logoImage}
                alt="Logo"
                className="h-5 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template3;
